import { render } from "./TransactionIO.vue?vue&type=template&id=248405a6"
import script from "./TransactionIO.vue?vue&type=script&lang=js"
export * from "./TransactionIO.vue?vue&type=script&lang=js"
script.render = render

export default script